// eslint-disable-next-line no-unused-vars
import React from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line no-unused-vars
import { Link } from '@americanexpress/one-app-router';

const NavLink = ({ children, pathname }) => {
  const selected = window?.location?.pathname === pathname;

  return (
    <li className="nav-item">
      <Link aria-selected={selected} aria-current={selected ? 'page' : 'false'} className="nav-link" to={pathname}>
        {children}
      </Link>
    </li>
  );
};

NavLink.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  pathname: PropTypes.string.isRequired,
};

export default NavLink;
